export default "__VITE_ASSET__DRfj$pf6__"